module.exports = __webpack_public_path__ + "img/img8.37e1fd12.jpg";